import React from "react";
import { Form } from "react-bootstrap";
import name from "../../assets/images/resource/name.svg";
import email from "../../assets/images/resource/email.svg";
import Phone from "../../assets/images/resource/mobile-dev.svg";
import company from "../../assets/images/resource/company.svg";
import NextBtn from "./nextbutton";

const StepFirst = ({
  handleStepChange,
  handleSubmit,
  handleSignup,
  register,
  errors,
  handleChange,
  check,
}) => {
  return (
    <div className='resource-step-content'>
      <div className='resource-step-heading'>
        <h4>Contact details</h4>
        <p>Lorem ipsum dolor sit amet consectetur adipisc.</p>
      </div>

      <div className='resource-form-contents'>
        <Form
          className='resource-form-content'
          onSubmit={handleSubmit(handleSignup)}
        >
          <div className='resource-form'>
            <Form.Group className='resource-dev-input'>
              <label>Name</label>
              <div className='resource-input'>
                <Form.Control
                  type='text'
                  name='Name'
                  placeholder='John Carter'
                  className={errors.Name ? "error-field" : ""}
                  {...register("Name")}
                  // onChange={(e) => handleChange(e.target.value)}
                />
                <img src={name} alt='name' />
              </div>
              {errors?.Name ? (
                <p className='error-text'>{errors?.Name?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>

            <Form.Group className='resource-dev-input'>
              <label>Email </label>
              <div className='resource-input'>
                <Form.Control
                  type='text'
                  name='email'
                  placeholder='Email address'
                  className={errors.email ? "error-field" : ""}
                  {...register("email")}
                  // onChange={(e) => handleChange(e.target.value)}
                />
                <img src={email} alt='email' />
              </div>
              {errors?.email ? (
                <p className='error-text'>{errors?.email?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
          <div className='resource-form'>
            <Form.Group className='resource-dev-input'>
              <label>Phone Number</label>
              <div className='resource-input'>
                <Form.Control
                  type='text'
                  name='phoneNumber'
                  placeholder='(123) 456 - 7890'
                  className={errors.phoneNumber ? "error-field" : ""}
                  {...register("phoneNumber")}
                  // onChange={(e) => handleChange(e.target.value)}
                />
                <img src={Phone} alt='Phone' />
              </div>
              {errors?.phoneNumber ? (
                <p className='error-text'>{errors?.phoneNumber?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
            <Form.Group className='resource-dev-input'>
              <label>Company</label>
              <div className='resource-input'>
                <Form.Control
                  type='text'
                  name='companyName'
                  placeholder='Company name'
                  className={errors.companyName ? "error-field" : ""}
                  {...register("companyName")}
                  // onChange={(e) => handleChange(e.target.value)}
                />
                <img src={company} alt='company' />
              </div>
              {errors?.companyName ? (
                <p className='error-text'>{errors?.companyName?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
          <div className='resource-form'>
            <Form.Group className='resource-dev-input'>
              <label>Job Description</label>
              <textarea
                placeholder='Lorem Ipsum'
                name='jobDescription'
                className={errors.jobDescription ? "error-field" : ""}
                {...register("jobDescription")}
                // onChange={(e) => handleChange(e.target.value)}
              />
              {errors?.jobDescription ? (
                <p className='error-text'>{errors?.jobDescription?.message}</p>
              ) : (
                ""
              )}
            </Form.Group>
          </div>
          <NextBtn handleStepChange={handleStepChange} check={check} />
        </Form>
      </div>
    </div>
  );
};

export default StepFirst;
